import {createAsyncThunk} from '@reduxjs/toolkit';
import {RootState} from '../../../store';
import {handlerError} from '../../../store/handleError';
import {INewTariff, ITariff} from '../../../models/ITariff';
import {tariffsAPI} from '../api';
import {setModalMessage} from '../../messages/model/slice';

export const fetchAddTariff = createAsyncThunk<
    ITariff,
    INewTariff,
    { state: RootState }
>('tariffs/add', async (tariff: INewTariff, {rejectWithValue, dispatch}) => {
    try {
        return await tariffsAPI.add(tariff);
    } catch (e) {
        const msg = handlerError(e);
        dispatch(setModalMessage(msg));
        return rejectWithValue(msg);
    }
});

export const fetchGetAllTariffs = createAsyncThunk(
    'tariffs/get_all',
    async (_, {rejectWithValue, dispatch}) => {
        try {
            return await tariffsAPI.getAll();
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchGetTariffById = createAsyncThunk(
    'tariffs/get_by_id',
    async (tariffId: string, {rejectWithValue, dispatch}) => {
        try {
            return await tariffsAPI.getById(tariffId);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchUpdateTariff = createAsyncThunk(
    'tariffs/update',
    async (tariff: ITariff, {rejectWithValue, dispatch}) => {
        try {
            return await tariffsAPI.update(tariff);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchDeleteTariff = createAsyncThunk(
    'tariffs/remove',
    async (tariffId: string, {rejectWithValue, dispatch}) => {
        try {
            return await tariffsAPI.delete(tariffId);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);